import { stats } from '@fiverr-private/obs';
import { METRICS_PREFIX } from '../constants';

export const metric = stats.prefix(`services.search_perseus.${METRICS_PREFIX}`);
